import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { JAWS_TYPES_IDS } from '../../../constants';
import getShipment from '../../../pages/PatientsPage/helpers/shipment';
import { RETAINER_CUT_TYPE_LABELS } from '../../RxForm/Retainer/constants';

const PatientLabel = ({ patient }) => {
  const shipment = getShipment(patient);
  let archLabel = '';

  switch (patient.rx_form.jaws_id) {
    case JAWS_TYPES_IDS.mandibular:
      archLabel = 'Lower';
      break;
    case JAWS_TYPES_IDS.maxillary:
      archLabel = 'Upper';
      break;
    default: {
      archLabel = 'Upper & Lower';
    }
  }

  const attn = shipment && shipment.location ? shipment.location.full_name : patient.user.name;
  const retainerOption = RETAINER_CUT_TYPE_LABELS[patient.rx_form.retainer_cut_type];
  const detail =
    shipment && shipment.kind === 'retainer'
      ? `Retainer${retainerOption ? ` (${retainerOption})` : ''} - ${archLabel}`
      : archLabel;

  return (
    <>
      {patient.last_name}, {patient.first_name}
      <br />
      Case #: {isEmpty(patient.case_number_text) ? 'N/A' : patient.case_number_text}
      <br />
      ATTN: {attn}
      <br />
      {detail}
    </>
  );
};

PatientLabel.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  patient: PropTypes.object.isRequired
};

export default PatientLabel;
